import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

const AdminRoute = ({ isAdmin, component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            isAdmin ? (<Component {...props} />) : (<Redirect to ={{pathname: "/login", state: {from: props.location}}} />)}
    />
);

AdminRoute.propTypes = {
    component: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
    isAdmin: state.auth.user.isAdmin
});

export default connect(mapStateToProps)(AdminRoute);
